import * as React from "react";
const SvgGemini = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "white" }),
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4312_133882)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18 10.016C15.9242 10.1434 13.9666 11.0255 12.496 12.496C11.0255 13.9666 10.1434 15.9242 10.016 18H9.984C9.85682 15.9241 8.97483 13.9664 7.5042 12.4958C6.03358 11.0252 4.07588 10.1432 2 10.016L2 9.984C4.07588 9.85682 6.03358 8.97483 7.5042 7.5042C8.97483 6.03358 9.85682 4.07588 9.984 2L10.016 2C10.1434 4.07581 11.0255 6.03339 12.496 7.50397C13.9666 8.97455 15.9242 9.85661 18 9.984V10.016Z",
      fill: "url(#paint0_radial_4312_133882)"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "radialGradient",
    {
      id: "paint0_radial_4312_133882",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(3.588 8.503) rotate(18.6832) scale(17.03 136.421)"
    },
    /* @__PURE__ */ React.createElement("stop", { offset: 0.067, stopColor: "#9168C0" }),
    /* @__PURE__ */ React.createElement("stop", { offset: 0.343, stopColor: "#5684D1" }),
    /* @__PURE__ */ React.createElement("stop", { offset: 0.672, stopColor: "#1BA1E3" })
  ), /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4312_133882" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(2 2)" })))
);
export default SvgGemini;
